<template>
  <div>
    <label
      class="grey--text text--darken-4 text-body-2 font-weight-medium"
      :for="label"
    >
      {{ title }}
    </label>

    <component
      :is="hasSearch ? 'VAutocomplete' : 'VSelect'"
      v-on="$listeners"
      v-bind="$attrs"
      v-model="model"
      class="text-body-2 font-weight-regular rounded-lg mt-1 form-control form-control-select"
      :menu-props="{ offsetY: true }"
      append-icon="mdi-chevron-down"
      :items="filteredItems"
      hide-details
      :id="label"
      outlined
      dense
    >
      <template v-if="hasSearch" v-slot:prepend-item>
        <div class="py-2 px-1">
          <v-text-field
            v-model="search"
            class="text-body-2 font-weight-regular form-control-input"
            background-color="rgba(0, 0, 0, 0.05)"
            :placeholder="'Buscar ' + title.toLowerCase()"
            hide-details
            autofocus
            clearable
            dense
            solo
          />
        </div>
      </template>

      <template v-slot:item="{ item }">
        <v-sheet
          class="d-flex align-center justify-space-between py-1"
          color="transparent"
          width="100%"
        >
          <span class="text-caption font-weight-regular">{{ item.text }}</span>

          <v-icon v-if="model === item.value" color="primary" right small>
            mdi-check
          </v-icon>
        </v-sheet>
      </template>

      <template v-slot:selection="{ item }">
        <span class="text-caption font-weight-regular text-ellipsis">
          {{ item.text }}
        </span>
      </template>
    </component>
  </div>
</template>

<script>
import VAutocomplete from "vuetify/lib/components/VAutocomplete";
import VSelect from "vuetify/lib/components/VSelect";

export default {
  components: { VAutocomplete, VSelect },
  props: {
    title: String,
    items: Array,
    value: {
      required: false,
    },
  },
  data: () => ({
    label: "",
    search: "",
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
    hasSearch() {
      return this.items?.length > 12;
    },
    filteredItems() {
      const normalize = (t) =>
        t
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      const s = normalize(this.search || "");

      const unselected = this.items.filter(
        (i) => !s || normalize(i.text).includes(s),
      );

      return [...unselected];
    },
  },
  created() {
    if (this.title)
      this.label = this.title
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z\s]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase();
  },
};
</script>

<style lang="scss" scoped>
.form-control-select::v-deep {
  input {
    min-width: 0 !important;
    width: 0;
  }
}

.form-control-input::v-deep {
  .v-input__slot {
    box-shadow: none !important;
  }
}
</style>
